import React, { useState, useEffect } from "react";
import axios from "axios";
import lwuImage from "../../Assets/lwu.webp";
import { Link } from "react-router-dom";

const FALLBACK = {
  title: "List With Us",
  description:
    "Maximize the value of your real estate with 365 Luxury Homes Dubai. We offer professional property management solutions for all types of properties, from stylish apartments to expansive villas, across Dubai's most prestigious neighborhoods. Our services streamline operations, enhance guest experiences, and ensure your property reaches its full rental potential.",
  buttonText: "Enquire Now",
  buttonUrl: "/list-with-us",
  backgroundImage: lwuImage,
};

const Listwithus = () => {
  const [data, setData] = useState(FALLBACK);

  useEffect(() => {
    const controller = new AbortController();
    axios
      .get("https://365luxuryhomes.com/api/home-content/listwithus", {
        signal: controller.signal,
      })
      .then((res) => {
        if (res.data) {
          setData((prev) => ({
            title: res.data.title || prev.title,
            description: res.data.description || prev.description,
            buttonText: res.data.buttonText || prev.buttonText,
            buttonUrl: res.data.buttonUrl || prev.buttonUrl,
            backgroundImage: res.data.backgroundImage || prev.backgroundImage,
          }));
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <div className="relative w-full flex items-center justify-center font-sans py-14">
      {/* Background Image Container */}
      <div className="absolute inset-0 z-0">
        <img
          src={data.backgroundImage}
          alt="A person holding a phone with the Airbnb app open"
          className="w-full h-full object-cover object-top"
        />
        {/* Semi-transparent overlay for better text readability */}
        <div className="absolute inset-0 bg-black opacity-20"></div>
      </div>

      {/* Content Section */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col md:flex-row items-center md:items-start space-y-8 md:space-y-0 md:space-x-12">
          {/* Text and Button on the left */}
          <div className="flex flex-col items-start w-full md:w-3/6 text-center md:text-left text-white ">
            <h2 className="text-3xl font-bold mb-4">{data.title}</h2>
            <p className="text-md font-light mb-8 text-left">
              {data.description}
            </p>
            <button className="bg-[#4d4b47] hover:bg-[#555451] text-[#fff]  py-2 px-8 rounded-lg shadow-lg transition-colors duration-300">
              <Link
                to={data.buttonUrl}
                className="no-underline text-white hover:no-underline active:no-underline focus:no-underline hover:text-white focus:text-white active:text-white"
              >
                {data.buttonText}
              </Link>
            </button>
          </div>

          {/* Right side for the image, hidden on smaller screens */}
          <div className="hidden md:flex w-full md:w-1/2 justify-center">
            {/* The image is part of the background, so this section is just for layout and spacing */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listwithus;
